import type { GaApp } from '~/modules/app'
import { IMAGE_MANIFEST } from '~/modules/main/constants/images'

export class SourcesService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }

  /** Данные видео сплеша */
  get splash() {
    return this.gaApp.stores.main.sources.splash
  }

  /** Флаг, указывающий, что все ресурсы загружены */
  get isAllLoaded() {
    return this.gaApp.stores.main.sources.isAllLoaded
  }

  /**
   * Загружает видео для экрана загрузки
   */
  async loadSplash() {
    this.gaApp.services.app.sourceLoader.loadVideoAsBinary(
      '/_static-files/splash.mp4',
      (video: HTMLVideoElement) => {
        this.setSplash(video)
      },
    )

    await this.gaApp.services.app.sourceLoader.start()
  }

  /** Сохранение данных видео сплеша в стору */
  setSplash(value: HTMLVideoElement) {
    this.gaApp.stores.main.sources.splash = value
  }

  /** Загрузка статики изображений */
  async loadImages() {
    this.gaApp.services.app.sourceLoader.loadImages(IMAGE_MANIFEST)
    await this.gaApp.services.main.prizes.loadPrizes()
    await this.gaApp.services.app.sourceLoader.start()
    this.gaApp.stores.main.sources.isAllLoaded = true
  }

  /** Загрузка стартовых ресурсов (видео сплеша) */
  async loadSources() {
    if (this.gaApp.services.main.main.needShowSplash) {
      // дожидаемся загрузку splash видео
      await this.loadSplash()

      // но не блокируем загрузкой остальных ресурсов
      void this.loadImages()
    } else {
      // в ином случае загружаем ресурсы сразу
      await this.loadImages()
    }
  }
}
